import { render } from "./Carousel.vue?vue&type=template&id=3a59adf0&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=3a59adf0&scoped=true&lang=css"

import exportComponent from "/Users/sebi/www/screen-app/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a59adf0"]])

export default __exports__